import React from "react";
import { CheckIcon } from "../../design-system/icons";
import { typography, surfaces, borders, textColors, interactive } from "../../design-system/tokens";

const TutorialStartPrompt = ({ onStart, onSkip }) => {
  return (
    <div
      className={[
        "w-[min(560px,calc(100vw-24px))]",
        "rounded-2xl border shadow-2xl",
        "px-4 py-3",
        "text-center",
        surfaces.elevated,
        borders.default,
      ].join(" ")}
      role="dialog"
      aria-label="Editor tutorial prompt"
    >
      <div className="flex justify-center" aria-hidden="true">
        <span
          className={[
            "h-14 w-14 rounded-full border-2",
            "inline-flex items-center justify-center",
            "border-green-400 dark:border-green-400",
            "text-green-400 dark:text-green-400",
          ].join(" ")}
        >
          <CheckIcon size="xl" color="inherit" />
        </span>
      </div>

      <div className="mt-2">
        <div className={`${typography.h5} ${textColors.brightest}`}>
          Welcome to{" "}
          <span className="text-green-400 dark:text-green-400">your</span>{" "}
          new website!{" "}
          <span className="text-green-400 dark:text-green-400">Want a 30-second tour?</span>
        </div>
        <div className={`${typography.bodySmall} ${textColors.secondary} mt-1`}>
          You can reopen the tutorial anytime from the top-left.
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2">
        <button
          type="button"
          onClick={onSkip}
          className={[
            "px-4 py-2 rounded-md",
            "transition-colors",
            typography.button,
            interactive.secondaryBg,
            interactive.secondaryHover,
            interactive.secondaryText,
          ].join(" ")}
        >
          Skip for now
        </button>
        <button
          type="button"
          onClick={onStart}
          className={[
            "px-4 py-2 rounded-md",
            "transition-colors",
            typography.button,
            interactive.primaryBg,
            interactive.primaryHover,
            interactive.primaryText,
          ].join(" ")}
        >
          Start tutorial
        </button>
      </div>
    </div>
  );
};

export default TutorialStartPrompt;

